import React from 'react';
import Cards from './Cards';
import Crausel from './Crausel';
import Container from './Container';


import Testimonials from './Testimonials';

const Home = () => {
    return (
        <div className="home-page">
            <Crausel />
            <Container />
            <Cards />
          
            <Testimonials />
    
        </div>
    );
};

export default Home;
